import React from "react";
import BG from "../../BG";
import Header from "../../Header";
import Body from "../../Body";
import Title from "../../Title";
import Subtitle from "../../Subtitle";
import Label from "../../Label";
import Text from "../../Text";
import Video from "../../Video";
import ButtonGroups from "../../ButtonGroups";
import Button from "../../Button";
import setCurrentPage from "src/Utils/setCurrentPage";
import List from "../../List";

interface TemplateProps {
  data: DataVideoJourney;
}

const Template = (props: TemplateProps) => {
  const {
    bgImage,
    title,
    subtitle,
    label,
    text,
    rightSideVideo,
    pageNumber,
    next,
    back,
    headerRightText,
    headerLeftImage,
    rightSideComponent,
    listData,
    styleListData,
    subtitleStyle,
    titleStyle,
    textStyle,
  } = props.data;

  const templateType = "video-journey-template";

  return (
    <BG bgImage={bgImage}>
      <Header
        onClickHome={() => setCurrentPage(1)}
        rightText={headerRightText}
        leftImage={headerLeftImage}
      />
      <Body>
        <div style={styles.container}>
          <div style={styles.panelLeft}>
            <div>
              <Subtitle
                style={subtitleStyle}
                type={templateType}
                text={subtitle}
              />
              <div style={{ marginTop: "52px" }}>
                {label && (
                  <Label
                    iconPath={label.iconPath}
                    type={templateType}
                    text={label.text}
                  />
                )}
                <Title style={titleStyle} type={templateType} text={title} />
                <Text style={textStyle} type={templateType} text={text} />
                {listData && (
                  <List
                    type={templateType}
                    customStyle={styleListData || {}}
                    listData={listData}
                  />
                )}
              </div>
            </div>
            <div>
              <ButtonGroups>
                {back && <Button {...back} />}
                {next && <Button {...next} />}
              </ButtonGroups>
            </div>
          </div>
          {rightSideVideo && (
            <Video
              pageNumber={pageNumber}
              style={styles.panelRight}
              styleVideo={styles.video}
              videoPath={rightSideVideo}
            />
          )}
          {rightSideComponent && rightSideComponent}
        </div>
      </Body>
    </BG>
  );
};

const styles = {
  container: {
    display: "flex",
    height: "-webkit-fill-available",
  },
  panelLeft: {
    zIndex: 2,
    flex: 1,
    height: "-webkit-fill-available",
    display: "flex" as React.CSSProperties["display"],
    flexDirection: "column" as React.CSSProperties["flexDirection"],
    justifyContent: "space-between",
  },
  panelRight: {
    flex: 1,
  },
  video: {
    position: "absolute" as React.CSSProperties["position"],
    top: "255px",
    right: "127px",
    zIndex: 1,
    width: "939px",
    borderRadius: "15px",
  },
};

export default Template;
